<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
  >
    <v-card class="elevation-8">
      <v-card-title class="d-flex align-center pa-6" :class="titleClass">
        <v-icon 
          :color="iconColor" 
          size="32" 
          class="mr-3"
        >
          {{ icon }}
        </v-icon>
        <span class="text-h6 font-weight-bold">
          {{ title }}
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <div class="text-body-1">
          {{ text }}
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-6 d-flex justify-end">
        <v-btn
          variant="outlined"
          color="grey-darken-1"
          @click="cancel"
          :disabled="loading"
          class="text-none mr-3"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="confirmColor"
          :loading="loading"
          @click="confirm"
          class="text-none px-6"
        >
          <v-icon start>{{ confirmIcon }}</v-icon>
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmar Acción'
    },
    text: {
      type: String,
      default: '¿Estás seguro de que quieres continuar?'
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'success', 'warning', 'error', 'info'].includes(value)
    },
    confirmText: {
      type: String,
      default: 'Confirmar'
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirmed', 'cancelled'],
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    titleClass() {
      const colorMap = {
        primary: 'bg-blue-lighten-5',
        success: 'bg-green-lighten-5',
        warning: 'bg-orange-lighten-5',
        error: 'bg-red-lighten-5',
        info: 'bg-blue-lighten-5'
      }
      return colorMap[this.color] || colorMap.primary
    },

    iconColor() {
      return this.color
    },

    confirmColor() {
      return this.color
    },

    icon() {
      const iconMap = {
        primary: 'mdi-help-circle',
        success: 'mdi-check-circle',
        warning: 'mdi-alert',
        error: 'mdi-alert-circle',
        info: 'mdi-information'
      }
      return iconMap[this.color] || iconMap.primary
    },

    confirmIcon() {
      const iconMap = {
        primary: 'mdi-check',
        success: 'mdi-check',
        warning: 'mdi-alert',
        error: 'mdi-delete',
        info: 'mdi-check'
      }
      return iconMap[this.color] || iconMap.primary
    }
  },
  watch: {
    modelValue(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('update:modelValue', val)
    }
  },
  methods: {
    confirm() {
      this.$emit('confirmed')
      this.dialog = false
    },

    cancel() {
      this.$emit('cancelled')
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.v-btn.text-none {
  text-transform: none;
  letter-spacing: normal;
}

.bg-blue-lighten-5 {
  background-color: rgba(33, 150, 243, 0.1) !important;
}

.bg-green-lighten-5 {
  background-color: rgba(76, 175, 80, 0.1) !important;
}

.bg-orange-lighten-5 {
  background-color: rgba(255, 152, 0, 0.1) !important;
}

.bg-red-lighten-5 {
  background-color: rgba(244, 67, 54, 0.1) !important;
}

.v-card-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.v-card-actions {
  background: rgba(0, 0, 0, 0.02);
}
</style>